//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import FormDetail from "@/0/components/comForm/comFormDetailGroupView";
import FormOperateList from "@/0/components/comForm/comOperateList/comFormOperateList2.vue";

export default {
  components: {
    "page-header": PageHeader,
    "form-detail": FormDetail,
    "form-operate-list": FormOperateList,
  },
  props: ["dataConfig"],
  data() {
    return {

      headerConfig: {
        Title: "单据详情"
      },
      isFormInit: false,

      openId: null,
      dataItem: null,
      formItem: null,

      formConfig: {},

      formControlViewList: [],
      formViewDataList: []
    };
  },

  async created() {

    var url = this.getFormViewUrl();
    await this.initForm(url);

  },

  methods: {

    $getComPage(){
      return this;
    },

    getFormViewUrl() {
      var url = this.dataConfig.Form.Url;
      return url;
    },

    $getSubmitData(){
      var formData = this.$refs.comFormDetail.$getSubmitData();
      return formData;
    },

    async loadForm(url) {
      await this.initForm(url);
    },

    async initForm(url,postData) {
      this.isFormInit = false;
      var openId = this.$route.query.openId;
      console.log("openId", openId);
      if (!openId) {
        this.$msg.alert("找不到单据标识[openId]");
        return;
      }
      if(!postData){
        postData = {};
      }
      postData.OpenId = openId;
      this.$msg.showLoading("正在加载...");
      var result = await this.$web.post(url,postData);
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.openId = openId;
        this.isFormInit = true;
        this.$msg.succ("加载完成");

        var resultData = result.data;

        this.formItem = result.data;
        this.dataItem = result.data.DataItem;

        this.headerConfig.Title = resultData.Title;
        this.formViewDataList = resultData.GroupViewList;

        this.formControlViewList = resultData.ControlViewList;

        setTimeout(() => {
          console.log("this.$refs.comFormOperateList",this.$refs.comFormOperateList);
          this.$refs.comFormOperateList.setData(resultData.OperateList);
        },0);
        return;
      }
      this.$msg.alert(result.msg);
    },    

    $getActionObj(){
      var actionObj = this.$refs.comFormOperateList.$getActionObj();
      console.log("actionObj",actionObj);
      return actionObj;
    },


    refreshForm() {
      this.initForm();
    },

    $refreshForm() {
      this.initForm();
    },

  }
};
